<template>
  <div id="auditTop" class="main-page-content">
    <PageHeaderLayout :isBack="true">
      <div style="background: #fff; padding: 20px 20px">
        <el-form
          :inline="true"
          :model="searchCondition"
          class="demo-form-inline"
        >
          <el-form-item label="任务名称">
            <el-input
              clearable
              v-model="searchCondition.title"
              placeholder="请输入任务名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              clearable
              v-model="searchCondition.examine_status"
              placeholder="审核状态"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <DatePicker @dataSearch="dataSearch" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
          </el-form-item>
        </el-form>
        <div style="margin: 0 20px">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#fbfbfb' }"
          >
            <el-table-column
              prop="title"
              label="任务名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              align="center"
            >
            <template slot-scope="scope">
                {{ scope.row.sex==1?'男':'女' }}
              </template>
          </el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              label="联系电话"
              align="center"
            ></el-table-column>
            <el-table-column label="薪资" align="center">
              <template slot-scope="scope">
                {{ scope.row.audit_salary || "-" }}
              </template>
            </el-table-column>
            
            <el-table-column prop="examine_status" label="状态" align="center">
              <template slot-scope="scope">
                {{ options_text[scope.row.examine_status] }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.examine_status == '0'"
                  size="mini"
                  type="primary"
                  @click="examineClick(scope.row)"
                  >审核</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-dialog
        v-if="examinedialogVisible"
        title=""
        :visible.sync="examinedialogVisible"
        width="50%"
        @close="closedialogVisible"
      >
        <el-form label-width="100px">
          <el-form-item label="审核结果">
            <el-radio-group v-model="radio">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="radio === 1" label="薪资">
            <el-input
              v-model.trim="userList.audit_salary"
              placeholder="请输入薪资"
              clearable
              style="max-width: 260px"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closedialogVisible">取 消</el-button>
          <el-button type="primary" @click="saveConfirm">确 定</el-button>
        </span>
      </el-dialog>

      <el-pagination
        style="float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagege.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagege.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagege.total"
      ></el-pagination>
    </PageHeaderLayout>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  components: {
    DatePicker,
    PageHeaderLayout,
  },
  data() {
    return {
      query: {},
      shenheData: [],
      options_text: ["待审核", "审核通过", "审核拒绝"],
      options: [
        {
          value: "0",
          label: "待审核",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "2",
          label: "审核拒绝",
        },
      ],
      searchCondition: {},
      pagege: {},
      currentPage2: "",
      id: "",
      Status: "",
      mission_content: "",

      userList: {
        textarea: "",
        audit_salary: "",
      },
      radio: 1,
      examinedialogVisible: false,
      tableData: [],
      ispage: 1,
      num: 10,
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  },

  methods: {
    closedialogVisible(){
      this.examinedialogVisible = false;
      this.radio = 1;
      this.userList.audit_salary = "";
    },
    // 搜索
    searchButton() {
      this.init();
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log(value);
      this.searchCondition.time = {};
      this.searchCondition.time.start_time = value[0];
      this.searchCondition.time.end_time = value[1];
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.num = val;
      this.ispage = 1;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.ispage = val;
      this.init();
    },
    async init() {
      let objects = {
        current_page: this.ispage,
        page_size: this.num,
        title: this.searchCondition.title,
        time: this.searchCondition.time,
        recruit_task_id: this.query.id,
        examine_status:this.searchCondition.examine_status
      };
      let res = {};
      res = await this.$api.getDaily_PrivateTaskJoin_list(objects);
      let { data, pages } = res;
      console.log(pages);
      this.tableData = data;
      this.pagege = pages;
    },

    userClose() {},
    examineClick(row) {
      this.id = row.id;
      this.radio = 1;
      this.userList.textarea = "";
      this.userList.audit_salary = "";
      this.examinedialogVisible = true;
    },
    // 确认保存按钮
    async saveConfirm() {
      if (this.radio === 1 && this.userList.audit_salary !== "") {
        const salary = Number(this.userList.audit_salary);
        if (Number.isNaN(salary)) {
          this.$message.error("薪资须为数字");
          return false;
        }
        if (salary < 0) {
          this.$message.error("薪资不能为负数");
          return false;
        }
      }
      this.userInfo();
      return true;
    },
    async userInfo() {
      let obj = {
        id: this.id,
        examine_status: this.radio,
      };
      if (this.radio === 1 && this.userList.audit_salary !== "") {
        obj.audit_salary = Number(this.userList.audit_salary);
      }

      await this.$api.postDaily_private_signup_audit(obj);
      this.$nextTick(() => {
          this.$message.success("审核成功!");
          this.init();
          this.closedialogVisible()
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-page-content {
  padding-bottom: 50px;
}
</style>
